
// import Image from "next/image";
// import Link from "next/link";
// import { useAppContext } from "@/context/Context";
// import React, { useEffect, useState } from "react";

// import sal from "sal.js";

// import boxedLogo from "../../public/images/logo/boxed-logo.png";
// import google from "../../public/images/sign-up/google.png";
// import facebook from "../../public/images/sign-up/facebook.png";
// import PageHead from "@/pages/Head";
// import {auth} from '@/context/firebaseconfig'
// import { createUserWithEmailAndPassword } from "firebase/auth";


// const UserAuth = () => {
//   const { toggleAuth, setToggleAuth } = useAppContext();


//   useEffect(() => {
//     sal();

//     const cards = document.querySelectorAll(".bg-flashlight");

//     cards.forEach((bgflashlight) => {
//       bgflashlight.onmousemove = function (e) {
//         let x = e.pageX - bgflashlight.offsetLeft;
//         let y = e.pageY - bgflashlight.offsetTop;

//         bgflashlight.style.setProperty("--x", x + "px");
//         bgflashlight.style.setProperty("--y", y + "px");
//       };
//     });
//   }, []);

//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setError('');
//     try {

//    await   createUserWithEmailAndPassword(auth, email, password);
//       // Handle success, maybe redirect or clear form
//     } catch (error) {
//       setError(error.message);
//     }
//   };

//   return (
//     <>
//       <PageHead title={`${toggleAuth ? "Log In" : "SignUp"}`} />
//       <div
//         className="signup-area jureeltd-section-gapTop-big"
//         data-black-overlay="2"
//       >
//         <div className="sign-up-wrapper jureeltd-section-gap">
//           <div className="sign-up-box bg-flashlight">
//             <div className="signup-box-top top-flashlight light-xl">
//               <Image
//                 src={boxedLogo}
//                 width={476}
//                 height={158}
//                 alt="sign-up logo"
//               />
//             </div>
//             <div className="separator-animated animated-true"></div>
//             <div className="signup-box-bottom">
//               <div className="signup-box-content">
//                 <h4 className="title">Welcome Back!</h4>
//                 <div className="social-btn-grp">
//                   <Link className="btn-default btn-border" href="#">
//                     <span className="icon-left">
//                       <Image
//                         src={google}
//                         width={18}
//                         height={18}
//                         alt="Google Icon"
//                       />
//                     </span>
//                     Login with Google
//                   </Link>
//                   <Link className="btn-default btn-border" href="#">
//                     <span className="icon-left">
//                       <Image
//                         src={facebook}
//                         width={18}
//                         height={18}
//                         alt="Google Icon"
//                       />
//                     </span>
//                     Login with Facebook
//                   </Link>
//                 </div>
//                 <div className="text-social-area">
//                   <hr />
//                   <span>Or continue with</span>
//                   <hr />
//                 </div>
//                 {toggleAuth ? ( 
//                    <form>
//                     <div className="input-section mail-section">
//                       <div className="icon">
//                         <i className="feather-mail"></i>
//                       </div>
//                       <input type="email" placeholder="Enter email address" />
//                     </div>
//                     <div className="input-section password-section">
//                       <div className="icon">
//                         <i className="feather-lock"></i>
//                       </div>
//                       <input type="password" placeholder="Password" />
//                     </div>
//                     <div className="forget-text">
//                       <Link className="btn-read-more" href="#">
//                         <span>Forgot password</span>
//                       </Link>
//                     </div>
//                     <button type="submit" className="btn-default">
//                       Sign In
//                     </button>
//                   </form> 
//                  ) : ( 


//       {/* {error && <p style={{ color: 'red' }}>{error}</p>}
//       <form onSubmit={handleSubmit}>
//         <input
//           type="email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           placeholder="Email"
//         />
//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           placeholder="Password"
//         />
//         <button type="submit">Sign Up</button>
//       </form> */}

//                     <form >
//                   <div>
//                     <div className="input-section mail-section">
//                       <div className="icon">
//                         <i className="feather-user"></i>
//                       </div>
//                       <input type="text" value={'areeb'} placeholder="Enter Your Name" />
//                     </div>
//                     <div className="input-section mail-section">
//                       <div className="icon">
//                         <i className="feather-mail"></i>
//                       </div>
//                       <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter email address" />
//                     </div>
//                     <div className="input-section password-section">
//                       <div className="icon">
//                         <i className="feather-lock"></i>
//                       </div>
//                       <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Create Password" />
//                     </div>
//                     {/* // <div className="input-section password-section">
//                     //   <div className="icon">
//                     //     <i className="feather-lock"></i>
//                     //   </div>
//                     //   <input type="password" placeholder="Confirm Password" />
//                     // </div> */}
//                     <button type="submit" className="btn-default"
//                     >
//                       Sign Up
//                     </button>
//                   </div>
//                   </form> 
//                 )} 
//               </div>
//               <div className="signup-box-footer">
//                 <div className="bottom-text">
//                   Don&apos;t have an account?
//                   <Link
//                     className="btn-read-more ps-2"
//                     href="#"
//                     onClick={() => setToggleAuth(!toggleAuth)}
//                   >
//                     {toggleAuth ? <span>Sign Up</span> : <span>Sign In</span>}
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//     </>
//   );
// };

// export default UserAuth;


import Image from "next/image";
import Link from "next/link";
import { useAppContext } from "@/context/Context";
import React, { useEffect, useState } from "react";

import sal from "sal.js";

import boxedLogo from "../../public/images/logo/boxed-logo.png";
import google from "../../public/images/sign-up/google.png";
import facebook from "../../public/images/sign-up/facebook.png";
import PageHead from "@/pages/Head";
import auth from '@/context/firebaseconfig';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useRouter } from "next/router";

const UserAuth = () => {
  const { toggleAuth, setToggleAuth } = useAppContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  const router = useRouter();

  useEffect(() => {
    sal();

    const cards = document.querySelectorAll(".bg-flashlight");

    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;

        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (email.endsWith('.ac.uk')) {
      console.log("The email belongs to an academic institution in the UK.");

    } else {
      console.log("The email does not belong to an academic institution in the UK.");
      setError('This email  doesnt belong to .ac.uk')
    }
    setError('');
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      // Handle success, maybe redirect or clear form
      alert('login succefull ');
      
      setEmail('');
      setPassword('');
      router.push('/profile-details') 
    } catch (error) {
      setError(error.message);
    }
  };

  const handlesignIn = async (event) => {
    event.preventDefault(); // Prevents the default form submission behavior
    setError('');
  
    try {
      // Assuming signIn is a function you've imported or defined that handles the sign-in logic
      const result = await signIn('credentials', { email, password, redirect: true });
  
      if (result.error) {
        setError(result.error);
      } else {
        // Assuming you want to redirect the user after successful sign-in
        router.push('/profile-details') 
      }
    } catch (error) {
      setError(error.message);
    }
  };
  

  return (
    <>
      <PageHead title={`${toggleAuth ? "Log In" : "SignUp"}`} />
      <div className="signup-area jureeltd-section-gapTop-big" data-black-overlay="2">
        <div className="sign-up-wrapper jureeltd-section-gap">
          <div className="sign-up-box bg-flashlight">
            <div className="signup-box-top top-flashlight light-xl">
              <Image src={boxedLogo} width={476} height={158} alt="sign-up logo" />
            </div>
            <div className="separator-animated animated-true"></div>
            <div className="signup-box-bottom">
              <div className="signup-box-content">
                <h4 className="title">Welcome Back!</h4>
                <div className="social-btn-grp">
                  <Link className="btn-default btn-border" href="#">
                    <span className="icon-left">
                      <Image src={google} width={18} height={18} alt="Google Icon" />
                    </span>
                    Login with Google
                  </Link>
                  <Link className="btn-default btn-border" href="#">
                    <span className="icon-left">
                      <Image src={facebook} width={18} height={18} alt="Google Icon" />
                    </span>
                    Login with Facebook
                  </Link>
                </div>
                <div className="text-social-area">
                  <hr />
                  <span>Or continue with</span>
                  <hr />
                </div>
                 {toggleAuth ? ( 
                  <form onSubmit={handlesignIn}> 
                    <div className="input-section mail-section">
                      <div className="icon">
                        <i className="feather-mail"></i>
                      </div>
                      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter email address" />
                    </div>
                    <div className="input-section password-section">
                      <div className="icon">
                        <i className="feather-lock"></i>
                      </div>
                      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
                    </div>
                    <div className="forget-text">
                      <Link className="btn-read-more" href="#">
                        <span>Forgot password</span>
                      </Link>
                    </div>
                    <button type="submit" className="btn-default">
                      Sign In
                    </button>
                  </form>
                 ) :
                ( 
                  <form onSubmit={handleSubmit}>
                    {/* <div> */}
                    <div className="input-section mail-section">
                      <div className="icon">
                        <i className="feather-user"></i>
                      </div>
                      <input type="text" placeholder="Enter Your Name" /> {/* Removed hardcoded value */}
                    </div>
                    <div className="input-section mail-section">
                      <div className="icon">
                        <i className="feather-mail"></i>
                      </div>
                      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter email address" />
                    </div>
                    <div className="input-section password-section">
                      <div className="icon">
                        <i className="feather-lock"></i>
                      </div>
                      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Create Password" />
                    </div>
                    <button type="submit" className="btn-default">
                      Sign Up
                    </button>
                    {/* </div> */}
                  </form>
                 )} 
              </div>
              <div className="signup-box-footer">
                <div className="bottom-text">
                  Don't have an account?
                  <Link className="btn-read-more ps-2" href="#" onClick={() => setToggleAuth(!toggleAuth)}>
                    {toggleAuth ? <span>Sign Up</span> : <span>Sign In</span>}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserAuth;
